import { render } from "./accordion.vue?vue&type=template&id=b07f17f6"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__